// filepath: c:\Users\magic\Gitlab\gameServer\src\app\pages\board-game\games\generated\help\GameRules.jsx
import React, { useState } from "react";
import Box from "@mui/material/Box";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/**
 * Detail view for the "Règles du jeu" card.
 * Props:
 * - rules: Array<{ key: string, text: string }>
 * - onBack: function to return to the cards grid
 */
const GameRules = ({ rules = [], onBack }) => {
  const [expandedKey, setExpandedKey] = useState(null);

  const handleToggle = (key) => {
    setExpandedKey((prev) => (prev === key ? null : key));
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 , marginBottom: "120px"}}>
      {/* Back control (replaces Help header/close while in detail) */}
      <button
        aria-label="Retour"
        onClick={onBack}
        style={{
          alignSelf: "flex-start",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          background: "transparent",
          color: "#fff",
          border: "none",
          fontSize: 16,
          fontWeight: 600,
          cursor: "pointer",
          padding: 8,
          borderRadius: 8,
        }}
      >
        <ArrowBackIosNewIcon fontSize="small" />
        Retour
      </button>

      {/* Rules as collapsible cards */}
      <div>
        {rules.map(({ key, text }) => (
          <Accordion
            key={key}
            expanded={expandedKey === key}
            onChange={() => handleToggle(key)}
            disableGutters
            square={false}
            sx={{
              mb: 1,
              borderRadius: 2,
              background:
                expandedKey === key
                  ? "linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.04))"
                  : "linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))",
              color: "#fff",
              boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
              overflow: "hidden",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon htmlColor="#fff" />}
              aria-controls={`${key}-content`}
              id={`${key}-header`}
              sx={{
                minHeight: 56,
                ".MuiAccordionSummary-content": { my: 0 },
              }}
            >
              <div style={{ fontWeight: 700 }}>{key}</div>
            </AccordionSummary>
            <AccordionDetails id={`${key}-content`}>
              <div style={{ opacity: 0.9, lineHeight: 1.4 }}>{text}</div>
            </AccordionDetails>
          </Accordion>
        ))}
        {rules.length === 0 && (
          <div style={{ opacity: 0.7 }}>Aucune règle à afficher.</div>
        )}
      </div>
    </Box>
  );
};

export default GameRules;
